import CityPageTemplate from "../city-template/CityPageTemplate";
import { newarkDeConfig } from "./data";

export default function NewarkDePage() {
  return <CityPageTemplate config={newarkDeConfig} />;
}